import {
  FoldOptionLeft,
  FoldOptionRight,
  LeftFold,
  RightFold,
  TopFoldHeaderContainer,
} from '@/components/general/TopFold';
import useIsMobile from '@/hooks/useIsMobile';
import FoldArrow from '../general/FoldArrow';

export type PossibleModes = 'Withdrawals' | 'Migrate' | 'Confirm' | 'Claim';

type Props = {
  mode: PossibleModes;
  setMode: (mode: PossibleModes) => void;
};

function StakeTopFold({ mode, setMode }: Props) {
  const isMobile = useIsMobile();
  const text = isMobile ? 'Almost there' : "You're almost there";

  return (
    <TopFoldHeaderContainer>
      <LeftFold>
        <FoldOptionLeft selected>{text}</FoldOptionLeft>
      </LeftFold>
      <RightFold>
        <FoldOptionRight disabled selected={mode === 'Withdrawals'}>
          1. Follow us on 𝕏
        </FoldOptionRight>
        <FoldArrow />
        <FoldOptionRight disabled selected={mode === 'Confirm'}>
          2. Connect Wallet
        </FoldOptionRight>
        <FoldArrow />
        <FoldOptionRight disabled selected={mode === 'Claim'}>
          3. Mana
        </FoldOptionRight>
      </RightFold>
    </TopFoldHeaderContainer>
  );
}

export default StakeTopFold;
